<template>
    <div class="fixed-bottom" v-if="isCloseAd">
        <section class="buyBox  relative">
            <img  src="@/assets/images/others/icon_close.png" class="cursor" @click="closeAd" alt="">
            <div class=" mx-auto  flex">
                <div class="left">
                    <div class="subTitle">
                        训练数据采集终端“慧训智能服务终端”
                    </div>
                    <div class="context">
                        硬件全国产化丨数据采集报送丨数据融合对接丨共享共建共用
                    </div>
                </div>
                <div class="right">
                    <el-button class="" size="mini" @click="goProduct">立即采购</el-button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'buyLink',
    data() {
        return {
            isCloseAd: true,
        }
    },
    created() {

    },
    methods: {
        closeAd() {
            this.isCloseAd=false
            
        },
        goProduct(){
            this.$router.push("/product")
        }
    },

}
</script>

<style lang="scss" scoped>
.buyBox {
    width: 100%;
    margin: 0 auto;
    background: #143a4d;

    >img {
        position: absolute;
        right: 2px;
        top: 2px;
    }

    >div {
        color: #fff;
        width: 30%;
        padding: 20px 0;
        justify-content: center;
        align-items: center;

        >.left {
            >.subTitle {
                font-size: 26px;
                margin-bottom: 5px;
            }

            >.context {
                font-size: 16px;
                color: #d8f6f6;
            }
        }

        >.right {
            margin-left: 15px;

         
        }
    }
}

@media all and (max-width:500px) {
.buyBox {
    width: 100%;
    margin: 0 auto;
    background: #143a4d;
    padding:0 10px;
    >img {
        position: absolute;
        right: 2px;
        top: 2px;
    }

    >div {
        color: #fff;
        width: 100%;
        padding: 20px 0;
        justify-content: center;
        align-items: center;

        >.left {
            >.subTitle {
                font-size: 16px;
                margin-bottom: 5px;
            }

            >.context {
                font-size: 10px;
                color: #d8f6f6;
            }
        }

        >.right {
            margin-left: 15px;

         
        }
    }
}
}
</style>
